import React from 'react';
import logo from "../images/racila_logo.jpg";
import { Link } from 'react-router-dom';

const SimpleNavbar = () => {
  return (
    <nav className="w-full bg-white text-black py-4 fixed top-0 left-0 z-50 shadow-md">
      <div className="container mx-auto flex items-center justify-between px-6">
        <Link to="/" className="flex items-center">
          <img src={logo} alt="Racila Logo" className="w-12 h-auto rounded-md" />
        </Link>
        <Link
          to="/"
          className="text-black font-semibold text-lg hover:text-red-900 transition-colors underline"
        >
          Home
        </Link>
      </div>
    </nav>
  );
};

export default SimpleNavbar;
